// Sprach- und Marktwahl in der Fusszeile (blocks/footer-localization.liquid).
// Öffnet den Dialog, schliesst ihn per Klick daneben (ESC kann <dialog> selbst)
// und setzt die Länderflaggen aus dem ISO-Code: Regional-Indicator-Zeichen,
// damit keine feste Liste gepflegt werden muss.

const flagge = (code) =>
  /^[A-Z]{2}$/.test(code) ? String.fromCodePoint(...[...code].map((c) => 0x1f1a5 + c.charCodeAt(0))) : '';

class CdLocalization extends HTMLElement {
  connectedCallback() {
    const dialog = this.querySelector('dialog');
    const knopf = this.querySelector('[data-loc-open]');
    if (!dialog || !knopf) return;

    for (const el of this.querySelectorAll('[data-flag]')) {
      el.textContent = flagge(el.dataset.flag);
    }

    knopf.addEventListener('click', () => dialog.showModal());
    // Ein Klick auf den Hintergrund trifft den <dialog> selbst — sein Innenrand
    // aber auch. Deshalb über die Koordinaten entscheiden, nicht über das Ziel.
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      const drin = event.clientX >= r.left && event.clientX <= r.right && event.clientY >= r.top && event.clientY <= r.bottom;
      if (!drin) dialog.close();
    });
  }
}

if (!customElements.get('cd-localization')) {
  customElements.define('cd-localization', CdLocalization);
}
